/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_ISSUE_TRANSITION_OPT_IN = 'issue_transition_opt_in';

export const ISSUE_TRANSITION_OPT_IN_STATUS_RESOURCE_KEY = 'issue_transition_labs_opt_in_status';

export const ISSUE_TRANSITION_LABS_VISIBILITY_API =
	'/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';

export const DURATION_IN_WEEKS_DEFAULT = 8;
